import React from 'react';
import { List } from 'semantic-ui-react';

export const KsiSupportUseLand = ({ value }) => {
  switch (value) {
    case 'sensibilizasaun':
      return <List.Item key={value}>Sensibilizasaun</List.Item>;
    case 'treinamentu':
      return <List.Item key={value}>Treinamentu</List.Item>;
    case 'suporta_material':
      return <List.Item key={value}>Suporta material</List.Item>;
    case 'interkambio':
      return <List.Item key={value}>Interkambio</List.Item>;
    default:
      return '';
  }
};
